import { Injectable } from '@angular/core';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';
import { Pagination } from '@models/pagination.model';
import { Observable } from 'rxjs';
import { ReduxService } from '../../state-management/redux.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class WorkflowService {
  public isWorkflowProcessTabOpened: boolean = false;
  public ActiveProcessList: any[] = [];
  isLoad: boolean = true;
  public module_isStop: boolean;
  public active_module_name: string = '';
  public moduleName: string = '';
  public processRecordId: string = '';
  public centralizedProcessPagination: Pagination;
  public engine: any;
  public conditionArray: any;
  public actionsArray: any[] = [];
  public TaskList: { type: 'workflow' | 'business_rules'; data: any[] } = { type: 'workflow', data: [] };

  public workflowData: any = [];
  public triggerID: any = null;
  public importing: boolean = false;
  public isWorkflowOpened: boolean = false;

  RemixIcons: any[] = [
    { icon: 'fa-solid fa-circle-exclamation', type: 'icon' },
    { icon: 'fa-solid fa-paperclip', type: 'icon' },
    { icon: 'fa-solid fa-phone', type: 'icon' },
    { icon: 'fa-solid fa-headset', type: 'icon' },
    { icon: 'fa-regular fa-file', type: 'icon' },
    { icon: 'fa-regular fa-user', type: 'icon' },
    { icon: 'fa-regular fa-pen-to-square', type: 'icon' },
    { icon: 'fa-regular fa-envelope', type: 'icon' },
    { icon: 'fa-regular fa-folder', type: 'icon' },
    { icon: 'fa-regular fa-circle-question', type: 'icon' },
    { icon: 'fa-regular fa-folder-closed', type: 'icon' },
    { icon: 'fa-solid fa-book', type: 'icon' },
    { icon: 'fa-solid fa-plus', type: 'icon' },
    { icon: 'fa-regular fa-bell', type: 'icon' },
    { icon: 'fa-solid fa-users', type: 'icon' },
    { icon: 'fa-solid fa-display', type: 'icon' },
    { icon: 'fa-solid fa-house-chimney', type: 'icon' },
    { icon: 'fa-regular fa-address-book', type: 'icon' },
    { icon: 'fa-solid fa-arrows-rotate', type: 'icon' },
    { icon: 'fa-regular fa-circle-user', type: 'icon' },
    { icon: 'fa-regular fa-eye', type: 'icon' },
  ];

  workFlowAutomation: any = {
    title: '',
    desc: '',
    module: '',
    type: '',
    filter: [],
    created_at: '',
    updated_at: '',
    readonlyfilter: [],
    startoperationtime: {
      record_created: false,
      record_status_changes: false,
      record_assigned: false,
      record_fields_change: false,
      record_deleted: false,
    },
    canStart: false,
  };

  workFlow: any = {
    tigger_title: '',
    trigger_id: '',
    tigger_desc: '',
    isAction: '',
    date: '',
  };

  RecurryingEnds: any[] = [
    { id: 601, name: 'Never', label: 'never' },
    { id: 602, name: 'After', label: 'after' },
    { id: 603, name: 'On', label: 'on' },
  ];
  RecurringOccurance: any[] = [
    { id: 701, name: 'Day', label: 'day' },
    { id: 702, name: 'Week', label: 'week' },
    { id: 703, name: 'Fortnight', label: 'fortnight' },
    { id: 704, name: 'Month', label: 'month' },
    { id: 705, name: 'Quater', label: 'quater' },
    { id: 706, name: 'Semi-annual', label: 'semi_annual' },
  ];
  association_based: any[] = [
    { id: 701, name: 'Admin', value: 'admin' },
    { id: 702, name: 'Developer', value: 'developer' },
    { id: 703, name: 'External', value: 'external' },
    { id: 704, name: 'Internal', value: 'internal' },
    { id: 705, name: 'Sales Manager', value: 'sales-manager' },
  ];
  actionDeliverChannel = [
    { id: 802, name: 'contact', label: 'Contact' },
    { id: 804, name: 'form', label: 'Form' },
    { id: 806, name: 'status_based', label: 'Project Status' },
    { id: 807, name: 'association_based', label: 'Project Association' },
    { id: 801, name: 'staff', label: 'Staff' },
    { id: 805, name: 'team', label: 'Team' },
    { id: 803, name: 'role', label: 'User role' },
  ];

  actionSenderChannel = [
    { id: 800, name: 'system', label: 'System' },
    { id: 801, name: 'staff', label: 'Staff' },
    { id: 802, name: 'contact', label: 'Contact' },
    { id: 803, name: 'role', label: 'User role' },
  ];

  condition_array: any = [
    { con_id: '101', class: '', name: 'Create', type: 'create', icon: 'pi pi-plus', condition: true },
    { con_id: '102', class: '', name: 'Update', type: 'update', icon: 'fas fa-edit', condition: true },
    { con_id: '103', class: '', name: 'Delete', type: 'delete', icon: 'pi pi-trash', condition: true },
    { con_id: '104', class: '', name: 'Date', type: 'date', icon: 'pi pi-calendar', condition: true },
    { con_id: '105', class: '', name: 'Time Delay', type: 'time', icon: 'pi pi-clock', condition: true },
    { con_id: '106', class: '', name: 'User', type: 'user', icon: 'pi pi-user', condition: true },
    { con_id: '107', class: '', name: 'Field Required', type: 'input_field', icon: 'pi pi-wallet', condition: true },
    { con_id: '108', class: '', name: 'Validation', type: 'validation', icon: 'pi pi-check-circle', condition: true },
    { con_id: '109', class: '', name: 'Advanced Scheduling', type: 'advanced_scheduling', icon: 'pi pi-clock', condition: true },
  ];

  action_list: any = [
    { con_id: '201', class: '', name: 'Notification', type: 'action', action_type: 'notification', icon: 'pi pi-bell', condition: false },
    { con_id: '202', class: '', name: 'Email', type: 'action', action_type: 'email', icon: 'pi pi-envelope', condition: false },
    // { con_id: '203', class: '', name: 'Create Task', type: 'action', action_type: 'task', icon: 'pi pi-file-edit', condition: false },
    { con_id: '204', class: '', name: 'Update', type: 'action', action_type: 'update', icon: 'pi pi-sync', condition: false },
    { con_id: '205', class: '', name: 'Stop', type: 'action', action_type: 'stop', icon: 'pi pi-ban', condition: false },
    { con_id: '206', class: '', name: 'Clear', type: 'action', action_type: 'clear', icon: 'pi pi-times', condition: false },
  ];

  module_array: any[] = [
    { name: 'Contact', module_value: 'contacts', dropdown_selector: 'full_name' },
    // { name: 'Contract', module_value: 'contract', dropdown_selector: 'contract' },
    { name: 'Lead Management', module_value: 'lead_management', dropdown_selector: 'first_name' },
    { name: 'Listing', module_value: 'properties', dropdown_selector: 'property_address' },
    { name: 'Projects', module_value: 'projects', dropdown_selector: 'Project_Name' },
    { name: 'Project Lots', module_value: 'project_units', dropdown_selector: 'Project_Name' },
    { name: 'Property', module_value: 'properties_data', dropdown_selector: 'property_address' },
    // { name: 'Tasks', module_value: 'tasks', dropdown_selector: 'title' },
    { name: 'EOI', module_value: 'eoi', dropdown_selector: 'first_name' },
    { name: 'OFI', module_value: 'ofi', dropdown_selector: 'first_name' },
  ];

  readonly module_mapping = {
    contacts: 'Contact',
    contract: 'Contract',
    lead_management: 'Lead Management',
    properties: 'Listing',
    projects: 'Projects',
    project_units: 'Project Lots',
    properties_data: 'Property',
    tasks: 'Tasks',
    eoi: 'EOI',
    ofi: 'OFI',
  };

  triggerStartList: any[] = [
    { id: 1, name: 'Record is created', slug: 'record_created', record_created: false },
    { id: 4, name: 'Record fields update', slug: 'record_fields_change', record_fields_change: false },
    { id: 5, name: 'Record is deleted', slug: 'record_deleted', record_deleted: false },
  ];

  boolean_array: any = [
    { con_name: 'Equal to', con_value: 'equal_to' },
    { con_name: 'Exists', con_value: 'exists' },
    { con_name: 'Not equal', con_value: 'not_equal' },
    { con_name: 'Start with', con_value: 'start_with' },
    { con_name: 'Contains', con_value: 'contains' },
    { con_name: 'Contains Data', con_value: 'contains_data' },
    { con_name: 'Does not Contains', con_value: 'not_contains' },
    { con_name: 'Does not Contains Data', con_value: 'not_contains_data' },
    { con_name: 'Greater then', con_value: 'greater_then' },
    { con_name: 'Less then', con_value: 'less_then' },
    { con_name: 'Exist in library', con_value: 'exist_in_library' },
    { con_name: 'Not exist in library', con_value: 'not_exist_in_library' },
  ];
  timeHours: any = [
    { hours: 1 },
    { hours: 2 },
    { hours: 3 },
    { hours: 4 },
    { hours: 5 },
    { hours: 6 },
    { hours: 7 },
    { hours: 8 },
    { hours: 9 },
    { hours: 10 },
    { hours: 11 },
    { hours: 12 },
    { hours: 13 },
    { hours: 14 },
    { hours: 15 },
    { hours: 16 },
    { hours: 17 },
    { hours: 18 },
    { hours: 19 },
    { hours: 20 },
    { hours: 21 },
    { hours: 22 },
    { hours: 23 },
    { hours: 24 },
  ];

  constructor(
    private api: ApiService,
    private remmiConfirm: RemmiConfirmService,
    private redux: ReduxService
  ) {}

  /**
   * This method shows a confirmation popup before performing any action
   * @param event mouse event
   * @param callbackfunc callback function
   */
  showConfirmPopup(_event: Event, callbackfunc?: () => void) {
    this.remmiConfirm
      .ask({
        title: 'Proceed With Change?',
        message: 'This change to the record will affect the automation. Do you want to proceed?',
        confirmLabel: 'Proceed',
        tone: 'warning',
      })
      .subscribe(isConfirmed => isConfirmed && callbackfunc && callbackfunc());
  }

  /**
   * This method gets the altered module name
   * @param modulename module name
   */
  GetAlteredModuleName(modulename: string = '') {
    if (modulename) {
      return this.module_array.filter(trigger => trigger?.module_value?.toLowerCase() === modulename?.toLowerCase())?.[0]?.name?.toLocaleLowerCase();
    }
    return '';
  }

  /**
   * This method gets the trigger by id
   * @param id trigger id
   */
  GetOfficeTriggerById(id: string = ''): Observable<any> {
    return this.api.get(`/workflow/get-by-id/${id}`, false);
  }

  /**
   * This method gets the all triggers by office id
   * @param officeId office id
   */
  GetTriggerByOffices(_: any): Observable<any> {
    return this.api.get(`/workflow/get-all?office_id=${this.api.getOfficeId()}`);
  }

  /**
   * This method gets the tag manager information
   * @param officeId office id
   */
  GetTagManagerInformation(officeId: String) {
    return this.redux.getTags(officeId.toString(), false, 'listing');
  }

  /**
   * This method gets all office contacts
   */
  GetAllOfficeContacts() {
    return this.api.get(
      `/search-data?office_id=${this.api.getOfficeId()}&user_id=${this.api.getUserId()}&module=contacts&page=${1}&limit=${99999}&keyword=${''}`
    );
  }

  /**
   * This method gets all user roles
   */
  GetAllUserRoles() {
    return this.api.get(`/roles?per_page=all&office_id=${this.api.getOfficeId()}`);
  }

  /**
   * This method gets all offices
   */
  GetMyOffices() {
    return this.api.get(`/offices/my?per_page=all`);
  }

  /**
   * This method gets all office teams
   */
  GetOfficeTeams() {
    return this.api.get(
      `/search-data?office_id=${this.api.getOfficeId()}&user_id=${this.api.getUserId()}&module=teams&page=${1}&limit=${99999}&keyword=${''}`
    );
  }

  /**
   * This method gets the entities by id
   * @param entityId entity id
   */
  GetEntitiesById(entityId: string = '') {
    return this.api.get(`/eng/misc/entity/lookup?entityid=${entityId}&officeid=${this.api.getOfficeId()}`);
  }

  /**
   * This method gets the user entities
   * @param filter_results filter results
   */
  GetUserEntities(filter_results: any[] = []) {
    return this.api.get(
      `/eng/misc/user/lookup?entity=users&officeid=${this.api.getOfficeId()}&filters=${encodeURIComponent(JSON.stringify({ role_id: filter_results }))}`
    );
  }

  /**
   * This method gets the tags by module
   * @param moduleType module type
   */
  GetTagsByModule(moduleType: string = '') {
    return this.api.get(`/tags-by-module?office_id=${this.api.getOfficeId()}&module_type=${moduleType}`);
  }

  /**
   * This method gets the tags by filter
   * @param mslug module slug
   * @param tslug tag slug
   */
  GetTagsByFilter(mslug: string = '', tslug: string = '') {
    return this.api.get(`/general/tag-manager/get-by-filters?office_id=${this.api.getOfficeId()}&mslug=${mslug}&tslug=${tslug}`);
  }

  /**
   * This method gets the listing module list detail
   */
  GetLisitingModuleListDetail() {
    return this.api.get(`/listing/short-detail?office_id=${this.api.getOfficeId()}`);
  }

  /**
   * This method gets the property module list detail
   */
  GetPropertyModuleListDetail() {
    return this.api.get(`/property/short-detail?office_id=${this.api.getOfficeId()}`);
  }

  /**
   * This method gets the contract module list detail
   */
  GetContractModuleListDetail() {
    return this.api.get(`/contracts-short-detail?office_id=${this.api.getOfficeId()}`);
  }

  /**
   * This method gets the contact module list detail
   */
  GetContactModuleListDetail() {
    if (this.api.getOfficeId()) {
      return this.api.get(`/contacts?office_id=${this.api.getOfficeId()}&user_type=Contact`);
    }
  }

  /**
   * This method gets the project module list detail
   */
  GetProjectModuleListDetail() {
    return this.api.get(`/eng/misc/entity/getallbyname?entityname=byd_projects&userid=${this.api.getUserId()}&officeid=${this.api.getOfficeId()}`);
  }

  /**
   * This method gets the project units module list detail
   * @param projectIds project ids
   * @param workFlow_id workflow id
   */
  GetProjectUnitsModuleListDetail(projectIds: string[] = [], workFlow_id = null) {
    return this.api.post(`/unit-short-detail?office_id=${this.api.getOfficeId()}&workflow_id=${workFlow_id}`, { project_id: projectIds });
  }

  /**
   * This method gets the task module list detail
   */
  GetTaskModuleListDetail() {
    return this.api.get(`/tasks-short-detail?office_id=${this.api.getOfficeId()}`);
  }

  /**
   * This method gets the lead management module list detail
   */
  GetLeadManagementModuleListDetail() {
    return this.api.get(`/leads-short-detail?office_id=${this.api.getOfficeId()}`);
  }

  /**
   * This method gets the library module list detail
   */
  GetLibraryModuleListDetail() {
    return this.api.get(`/library-short-detail?office_id=${this.api.getOfficeId()}`);
  }

  /**
   * This method gets the all office users
   */
  GetAllOfficeUsers() {
    return this.api.get(`/users?office_id=${this.api.getOfficeId()}`);
  }

  /**
   * This method gets the all history processes
   * @param workflowId workflow id
   * @param process_record process record
   * @param pageNumber page number
   * @param pageSize page size
   */
  GetAllHistoryProcesses(workflowId: string = '', process_record: string = '', pageNumber = 1, pageSize = 10) {
    return this.api.get(
      `/workflow-history?workflow_id=${workflowId}&office_id=${this.api.getOfficeId()}&process_record=${process_record}&page=${pageNumber}&per_page=${pageSize}`
    );
  }

  /**
   * This method gets the workflow history detail by id
   * @param workflowId workflow id
   */
  GetWorkflowHistoryDetailById(workflowId: string = '') {
    return this.api.get(`/workflow-history-detail/${workflowId}`);
  }

  /**
   * This method gets the all processes by module
   * @param record_id record id
   * @param moduleName module name
   * @param pageNumber page number
   * @param pageSize page size
   * @param searchKeyword search keyword
   * @param type type
   */
  GetAllProcessesByModule(
    record_id,
    moduleName: string = 'properties',
    pageNumber: number = 1,
    pageSize: number = 10,
    searchKeyword: string = '',
    type: 'progress' | 'paused' | 'completed' = 'progress'
  ) {
    this.moduleName = moduleName;
    let url = `/workflow-process?office_id=${this.api.getOfficeId()}&module=${moduleName}&record_id=${record_id}&page=${pageNumber}&per_page=${pageSize}`;
    if (searchKeyword?.length > 0) {
      url += `&keyword=${searchKeyword}`;
    }
    if (type) {
      url += `&workflow_type=${type}`;
    }
    return this.api.get(url);
  }

  /**
   * This method updates the trigger by id
   * @param triggerId trigger id
   * @param updated_record updated record
   */
  UpdateTriggerById(triggerId, updated_record) {
    return this.api.put(`/workflow/update/${triggerId}`, updated_record);
  }

  /**
   * This method gets the task priorities
   */
  GetTaskPriorities() {
    return this.api.get(`/priorities?office_id=${this.api.getOfficeId()}`);
  }

  /**
   * This method gets the list of email sender's email addresses for the office
   */
  GetEmailSenderList() {
    return this.api.get(`/settings/office-smtps-list/${this.api.getOfficeId()}`);
  }

  //#region Workflow Inputfield Conditions

  SaveModuleInputFieldConditions(triggerId: string = '', conditionsArray: any[] = [], savedTitle = '', module = null) {
    return this.api.post(`/workflow/save-condition`, {
      office_id: this.api.getOfficeId(),
      workflow_id: triggerId,
      con_list: conditionsArray,
      title: savedTitle,
      module: module,
    });
  }

  GetWorkflowSavedConditons(_: string = '', module: string = '') {
    return this.api.get(`/workflow/get-saved-conditions?office_id=${this.api.getOfficeId()}&module=${module}`);
  }

  UpdateSavedWorkflowInputfieldCondition(id: string = '', conditionsArray: any[] = []) {
    return this.api.put(`/workflow/update-saved-condition/${id}`, { con_list: conditionsArray });
  }

  RemoveSavedWorkflowInputfieldCondition(id: string = '') {
    return this.api.delete(`/workflow/delete-saved-condition/${id}`);
  }

  getProjectStatusFromTagManager() {
    return this.api.get(`/general/tag-manager/get-by-filters?office_id=${this.api.getOfficeId()}&mslug=project&tslug=project-status`);
  }

  //#endregion
}
